
import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";

const Hero = () => {
  const { language } = useLanguage();

  const content = {
    title: language === 'sv' ? 'Specialister på marina drivmedel' : 'Marine Fuel Specialists',
    description: language === 'sv'
      ? 'Vi levererar alla sorters drivmedel i hela Sverige med bunkerfartyg och tankbilar till sjöstationer, fartyg, entreprenader och statliga myndigheter. Vi erbjuder även leveranser av större volymer och har kapacitet att möta behoven hos större fartyg och kunder.'
      : 'We deliver all types of fuels throughout Sweden with bunker vessels and tank trucks to marine stations, vessels, contractors, and government agencies. We also offer deliveries of larger volumes and have the capacity to meet the needs of larger vessels and customers.',
    orderButton: language === 'sv' ? 'Beställningsförfrågan Drivmedel' : 'Order Fuel'
  };

  const scrollToOrderForm = () => {
    const orderForm = document.getElementById('order-form');
    if (orderForm) {
      orderForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="/images/hav-bg.jpg"
          alt="Havsvy med bunkerfartyg vid Sveriges kust - Petrobell marina drivmedel"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>
      
      <div className="container mx-auto px-4 z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <img 
            src="https://image.jimcdn.com/app/cms/image/transf/dimension=574x10000:format=png/path/s411a2b5b18fcb029/image/ibf520ed4bd6a92ca/version/1505397001/image.png" 
            alt="Petrobell logotyp - Specialister på marina drivmedel sedan 1954"
            className="h-24 mx-auto mb-8"
          />
          <h1 className="text-3xl md:text-6xl font-bold text-white mb-6 tracking-tight break-words">
            {content.title}
          </h1>
          <p className="text-base md:text-xl text-white/90 max-w-2xl mx-auto mb-8 px-2">
            {content.description}
          </p>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={scrollToOrderForm}
            className="px-6 md:px-12 py-4 text-base md:text-lg bg-primary text-white rounded-lg font-medium transition-all hover:shadow-lg"
          >
            {content.orderButton}
          </motion.button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
